import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { isEmpty, isNil } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';
import { StandardAlertFormData } from '@/components/alerts/model';
import {
  translateOperator,
  translateSeverity,
  translateVariable,
} from '@/utils/alerts';
import { translateDateGrouping } from '@/utils/dates';
import { abbreviateNumber } from '@/utils/number';


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryWizardStep',
  props: {
    value: null
  },
  emits: ['enter'],
  setup(__props: any, { emit }) {





const { t } = useI18n();

return { __sfc: true,emit, t, WizardStep, isEmpty, isNil, translateOperator, translateSeverity, translateVariable, translateDateGrouping, abbreviateNumber }
}

})